module.exports = __webpack_public_path__ + "static/media/catat_prestasi.bf492584.png";